import { X } from "lucide-react";
import Eyebrow from "@/components/zeblan/Eyebrow";
import Reveal from "@/components/zeblan/Reveal";

const items = [
  { t: "We won't sell you AI if a spreadsheet will do", b: "If a simpler, cheaper tool solves your problem, we'll tell you." },
  { t: "We won't hold your data hostage", b: "Your agents, your data, your servers. We build it. You own the keys." },
  { t: "We won't pretend AI is magic", b: "It's just math and engineering. No buzzwords. Only predictable, reliable implementations." },
];

export default function WontDo() {
  return (
    <section className="bg-cloud py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="max-w-2xl">
          <Eyebrow tone="teal">Radical Honesty</Eyebrow>
          <h2 className="mt-6 text-navy font-extrabold tracking-tightish" style={{ fontSize: "clamp(30px,4vw,46px)" }}>
            What we <span className="text-blue">won't</span> do
          </h2>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {items.map((it, i) => (
            <Reveal key={it.t} delay={i * 80}>
              <article className="h-full bg-white border border-mist rounded-2xl p-8 hover:-translate-y-1 hover:shadow-[0_18px_40px_-22px_rgba(10,19,40,0.18)] transition-all duration-300">
                <div className="h-12 w-12 rounded-full grid place-items-center border-2 border-teal text-teal">
                  <X className="h-5 w-5" />
                </div>
                <h3 className="mt-5 text-navy text-[18px] font-bold">{it.t}</h3>
                <p className="mt-3 text-slate text-[15px] leading-relaxed">{it.b}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
